const data = {
  4: ["N", "E", "S", "W"],
  8: ["N ", "NE", "E ", "SE ", "S ", "SW", "W ", "NW"],
  16: ["N  ", "N/NE", "NE ", "E/NE", "E  ", "E/SE", "SE ", "S/SE", "S  ", "S/SW", "SW ", "W/SW", "W  ", "W/NW", "NW ", "N/NW"]
};
export default data;